export default "__VITE_ASSET__a1fc2df2__"